import { render, staticRenderFns } from "./RespostaEdit.vue?vue&type=template&id=96fe52c4&scoped=true&"
import script from "./RespostaEdit.vue?vue&type=script&lang=js&"
export * from "./RespostaEdit.vue?vue&type=script&lang=js&"
import style0 from "./RespostaEdit.vue?vue&type=style&index=0&id=96fe52c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe52c4",
  null
  
)

export default component.exports